import {VetologyBase} from "../Vetology/VetologyBase";

export class SHCustomize extends VetologyBase
{
    constructor ()
    {
        super('SHCustomize');
    }

    _create ()
    {

    }

    init ()
    {
        const _self = this;

	    const ImageElems = document.querySelectorAll('div.clinic_image_swap');
	    ImageElems.forEach((divElem) => {
		    const clinicID = divElem.dataset.clinic_id;
		    const queryString = new URLSearchParams();
		    queryString.append('clinicID', clinicID);
		    fetch('/clinic/manage/get-custom-logo-info?' + queryString.toString(),
			    {
				    method: 'get',
				    accept: 'json'
			    }).then((response) => {
			    if (response.ok) {
				    response.json().then(data => {
					    if (data.success) {
						    const clinicID = data.clinicID;
						    const logoDiv = document.querySelector('div.clinic_image_swap[data-clinic_id="' + clinicID + '"]');
						    if (logoDiv) {
							    const imgElem = logoDiv.querySelector('img');
							    const html = data.html;
							    const newDiv = document.createElement('div');
							    newDiv.classList.add('custom-logo-container');
							    newDiv.innerHTML = html;
							    logoDiv.insertBefore(newDiv, imgElem);
						    }
					    }
				    });
			    }
		    });
	    })
    }

}

